import { render, staticRenderFns } from "./PreviousZoomControl.vue?vue&type=template&id=01f9a76f&"
import script from "./PreviousZoomControl.vue?vue&type=script&lang=js&"
export * from "./PreviousZoomControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports